/*
 * 3d标签云
 * 功能：鼠标移入标签，当前标签静止放大
 * 说明：
 * */

const tagcloud = ((win, doc) => {
  // ns
  // 判断对象
  function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  }

  // 构造函数
  class TagCloud {
    constructor(options) {
      this.config = TagCloud.getConfig(options);
      this.box = this.config.element; // 组件元素
      this.fontsize = this.config.fontsize; // 平均字体大小
      this.radius = this.config.radius; // 滚动半径
      this.depth = 2 * this.radius; // 滚动深度
      this.size = 2 * this.radius; // 随鼠标滚动变速作用区域

      this.mspeed = TagCloud.getMsSpeed(this.config.mspeed);
      this.ispeed = TagCloud.getIsSpeed(this.config.ispeed);
      this.items = this.getItems();

      this.direction = this.config.direction; // 初始滚动方向
      this.keep = this.config.keep; // 鼠标移出后是否保持之前滚动

      // 初始化
      this.active = false; // 是否为激活状态
      this.lasta = 1;
      this.lastb = 1;
      this.mouseX0 = this.ispeed * Math.sin((this.direction * Math.PI) / 180); // 鼠标与滚动圆心x轴初始距离
      this.mouseY0 = -this.ispeed * Math.cos((this.direction * Math.PI) / 180); // 鼠标与滚动圆心y轴初始距离
      this.mouseX = this.mouseX0; // 鼠标与滚动圆心x轴距离
      this.mouseY = this.mouseY0; // 鼠标与滚动圆心y轴距离
      this.index = -1;

      // 鼠标移入
      TagCloud.on(this.box, 'mouseover', () => {
        this.active = true;
      });
      // 鼠标移出
      TagCloud.on(this.box, 'mouseout', () => {
        this.active = false;
      });

      // 鼠标在内移动
      TagCloud.on(this.keep ? win : this.box, 'mousemove', (ev) => {
        const oEvent = win.event || ev;
        const boxPosition = this.box.getBoundingClientRect();
        this.mouseX = (oEvent.clientX - (boxPosition.left + this.box.offsetWidth / 2)) / 5;
        this.mouseY = (oEvent.clientY - (boxPosition.top + this.box.offsetHeight / 2)) / 5;
      });

      for (let j = 0, len = this.items.length; j < len; j++) {
        this.items[j].element.index = j;

        // 鼠标移出子元素,当前元素静止放大
        this.items[j].element.onmouseover = () => {
          this.index = j;
        };

        // 鼠标移出子元素,当前元素继续滚动
        this.items[j].element.onmouseout = () => {
          this.index = -1;
        };
      }

      // 定时更新
      TagCloud.boxs.push(this.box);
      this.update(this); // 初始更新
      this.box.style.visibility = 'visible';
      this.box.style.position = 'relative';
      // this.box.style.minHeight = 1.2 * this.size + "px";
      // this.box.style.minWidth = 2.5 * this.size + "px";
      for (let j = 0, len = this.items.length; j < len; j++) {
        this.items[j].element.style.position = 'absolute';
        this.items[j].element.style.zIndex = j + 1;
      }
      this.up = setInterval(() => {
        this.update(this);
      }, 10);
    }

    // 静态方法们
    static set(element) {
      if (TagCloud.boxs.indexOf(element) === -1) {
        // ie8不支持数组的indexOf方法
        return true;
      }
      return false;
    }

    static getConfig(config) {
      const defaultConfig = {
        // 默认值
        fontsize: 16, // 基本字体大小, 单位px
        radius: 190, // 滚动半径, 单位px
        mspeed: 'normal', // 滚动最大速度, 取值: slow, normal(默认), fast
        ispeed: 'normal', // 滚动初速度, 取值: slow, normal(默认), fast
        direction: 135, // 初始滚动方向, 取值角度(顺时针360): 0对应top, 90对应left, 135对应right-bottom(默认)...
        keep: true, // 鼠标移出组件后是否继续随鼠标滚动, 取值: false, true(默认) 对应 减速至初速度滚动, 随鼠标滚动
      };

      if (isObject(config)) {
        for (const i in config) {
          if (Object.prototype.hasOwnProperty.call(config, i)) {
            // hasOwnProperty()用来判断一个属性是定义在对象本身而不是继承自原型链
            defaultConfig[i] = config[i]; // 用户配置
          }
        }
      }

      return defaultConfig; // 配置 Merge
    }

    static getMsSpeed(mspeed) {
      // 滚动最大速度
      const speedMap = {
        slow: 1.5,
        normal: 3,
        fast: 5,
      };
      return speedMap[mspeed] || 3;
    }

    static getIsSpeed(ispeed) {
      // 滚动初速度
      const speedMap = {
        slow: 5,
        normal: 10,
        fast: 15,
      };
      return speedMap[ispeed] || 25;
    }

    static getSc(a, b) {
      const l = Math.PI / 180;
      // 数组顺序0,1,2,3表示asin,acos,bsin,bcos
      return [Math.sin(a * l), Math.cos(a * l), Math.sin(b * l), Math.cos(b * l)];
    }

    static on(ele, eve, handler, cap) {
      if (ele.addEventListener) {
        ele.addEventListener(eve, handler, cap);
      } else if (ele.attachEvent) {
        ele.attachEvent(`on${eve}`, handler);
      } else {
        ele[`on${eve}`] = handler;
      }
    }

    update() {
      // let a;
      // let b;
      if (!this.active && !this.keep) {
        this.mouseX = Math.abs(this.mouseX - this.mouseX0) < 1 ? this.mouseX0 : (this.mouseX + this.mouseX0) / 2; // 重置鼠标与滚动圆心x轴距离
        this.mouseY = Math.abs(this.mouseY - this.mouseY0) < 1 ? this.mouseY0 : (this.mouseY + this.mouseY0) / 2; // 重置鼠标与滚动圆心y轴距离
      }

      const a = -(Math.min(Math.max(-this.mouseY, -this.size), this.size) / this.radius) * this.mspeed;
      const b = (Math.min(Math.max(-this.mouseX, -this.size), this.size) / this.radius) * this.mspeed;

      if (Math.abs(a) <= 0.01 && Math.abs(b) <= 0.01) {
        return;
      }

      this.lasta = a;
      this.lastb = b;

      const sc = TagCloud.getSc(a, b);

      for (let j = 0, len = this.items.length; j < len; j++) {
        const rx1 = this.items[j].x;
        const ry1 = this.items[j].y * sc[1] + this.items[j].z * -sc[0];
        const rz1 = this.items[j].y * sc[0] + this.items[j].z * sc[1];

        const rx2 = rx1 * sc[3] + rz1 * sc[2];
        const ry2 = ry1;
        const rz2 = rz1 * sc[3] - rx1 * sc[2];

        if (this.index === j) {
          this.items[j].scale = 1; // 取值范围0.6 ~ 3
          this.items[j].fontsize = 16;
          this.items[j].alpha = 1;
          this.items[j].element.style.zIndex = 99;
        } else {
          const per = this.depth / (this.depth + rz2);
          this.items[j].x = rx2;
          this.items[j].y = ry2;
          this.items[j].z = rz2;

          this.items[j].scale = per; // 取值范围0.6 ~ 3
          this.items[j].fontsize = Math.ceil(per * 2) + this.fontsize - 6;
          this.items[j].alpha = 1.5 * per - 0.5;
          this.items[j].element.style.zIndex = Math.ceil(per * 10 - 5);
        }
        // this.items[j].element.style.fontSize = this.items[j].fontsize + "px";//字体变大小
        this.items[j].element.style.left = `${
          this.items[j].x + (this.box.offsetWidth - this.items[j].offsetWidth) / 2
        }px`;
        this.items[j].element.style.top = `${
          this.items[j].y + (this.box.offsetHeight - this.items[j].offsetHeight) / 2
        }px`;
        this.items[j].element.style.filter = `alpha(opacity=${100 * this.items[j].alpha})`;
        this.items[j].element.style.opacity = this.items[j].alpha;
      }
    }

    getItems() {
      const items = [];
      const element = this.box.children; // children 全部是Element
      const { length } = element;
      let item;

      for (let i = 0; i < length; i++) {
        item = {};
        item.angle = {};
        item.angle.phi = Math.acos(-1 + (2 * i + 1) / length);
        item.angle.theta = Math.sqrt((length + 1) * Math.PI) * item.angle.phi;
        item.element = element[i];
        item.offsetWidth = item.element.offsetWidth;
        item.offsetHeight = item.element.offsetHeight;
        item.x = this.radius * 1.5 * Math.cos(item.angle.theta) * Math.sin(item.angle.phi);
        item.y = this.radius * 1.5 * Math.sin(item.angle.theta) * Math.sin(item.angle.phi);
        item.z = this.radius * 1.5 * Math.cos(item.angle.phi);
        item.element.style.left = `${item.x + (this.box.offsetWidth - item.offsetWidth) / 2}px`;
        item.element.style.top = `${item.y + (this.box.offsetHeight - item.offsetHeight) / 2}px`;
        items.push(item);
      }

      return items; // 单元素数组
    }
  }

  // 实例
  TagCloud.boxs = []; // 实例元素数组

  // 添加数组IndexOf方法
  if (!Array.indexOf) {
    Array.indexOf = (elt /* , from */, ...args) => {
      // eslint-disable-next-line no-bitwise
      const len = this.length >>> 0;
      let from = Number(args[1]) || 0;
      from = from < 0 ? Math.ceil(from) : Math.floor(from);
      if (from < 0) from += len;

      for (; from < len; from++) {
        if (from in this && this[from] === elt) return from;
      }
      return -1;
    };
  }

  if (!doc.querySelectorAll) {
    // ie7不支持querySelectorAll，所以要重新定义
    doc.querySelectorAll = (selectors) => {
      const style = doc.createElement('style');
      const elements = [];
      let element;
      doc.documentElement.firstChild.appendChild(style);
      doc.qsa = [];

      style.styleSheet.cssText = `${selectors}{x-qsa:expression(document.qsa && document.qsa.push(this))}`;
      window.scrollBy(0, 0);
      style.parentNode.removeChild(style);

      while (doc.qsa.length) {
        element = doc.qsa.shift();
        element.style.removeAttribute('x-qsa');
        elements.push(element);
      }
      doc.qsa = null;
      return elements;
    };
  }

  return (options) => {
    // factory
    options = options || {}; // 短路语法
    const selector = options.selector || '.tagcloud'; // 默认选择class为tagcloud的元素
    const elements = doc.querySelectorAll(selector);
    const instance = [];
    for (let index = 0, len = elements.length; index < len; index++) {
      options.element = elements[index];
      if (TagCloud.set(options.element)) {
        instance.push(new TagCloud(options));
      }
    }
    return instance;
  };
})(window, document);

export default tagcloud;
